import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonItem, IonLabel, IonPage, IonRow, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { findTemplatesForUserOrLocation } from "../../store/templateList/actions/findTemplatesForUserOrLocation";
import { selectULTemplateList } from "../../store/templateList/selectors/selectULTemplateList";
import { CreateFileTemplateButton } from "./components/CreateFileTemplateButton";
import { FileTemplateListContainer } from "./components/FileTemplateListContainer";
import { FileTemplateSearchBar } from "./components/FileTemplateSearchBar";
import { FilterFileTemplateList } from "./components/FilterFileTemplateList";

export const FileTemplateList: React.FC = () => {
    const ulTemplateList = useSelector(selectULTemplateList);
    const dispatch = useDispatch();

    useEffect(() => {
        if (ulTemplateList.length === 0) {
            dispatch(findTemplatesForUserOrLocation());
        }
    },[dispatch]);

    return (
        <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton color="light" defaultHref="/app/tic" />
                    </IonButtons>
                    <IonTitle>Plantillas de Archivos</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <CreateFileTemplateButton />
                <section className="ion-padding">
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <FileTemplateSearchBar />
                                <FilterFileTemplateList />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <FileTemplateListContainer />
                </section>
            </IonContent>
        </IonPage>
    );
};
